/**
 * Admin Module - GraphQL Queries & Mutations
 *
 * Centralized GraphQL operations for the admin module.
 * Extracted from inline definitions in component files.
 */

import { gql } from "@apollo/client";

// ==========================================
// Bill Chaser Queries & Mutations
// ==========================================

export const GET_BILL_CHASER_CONFIG = gql`
  query GetBillChaserConfiguration {
    getBillChaserConfiguration {
      enabled
      cronSchedule
      timezone
      sendToClients
      sendToIssuers
      sendSms
      sendEmails
      maxBillsPerRun
      minBillAgeInDays
      scheduleDescription
    }
  }
`;

export const RUN_BILL_CHASER_MANUALLY = gql`
  mutation RunBillChaserManually($input: BillChaserRunInput) {
    runBillChaserManually(input: $input) {
      success
      message
      startTime
      endTime
      duration
      totalBillsFound
      billsProcessed
      billsSkipped
      clientSmsSuccessful
      clientSmsFailed
      issuerSmsSuccessful
      issuerSmsFailed
      clientEmailsSuccessful
      clientEmailsFailed
      issuerEmailsSuccessful
      issuerEmailsFailed
      systemErrors
    }
  }
`;

export const UPDATE_BILL_CHASER_CONFIG = gql`
  mutation UpdateBillChaserConfiguration($input: BillChaserConfigInput!) {
    updateBillChaserConfiguration(input: $input) {
      enabled
      cronSchedule
      timezone
      sendToClients
      sendToIssuers
      maxBillsPerRun
      minBillAgeInDays
      scheduleDescription
    }
  }
`;

export const ENABLE_BILL_CHASER = gql`
  mutation EnableBillChaser($enabled: Boolean!) {
    enableBillChaser(enabled: $enabled) {
      enabled
      scheduleDescription
    }
  }
`;

export const CONFIGURE_NOTIFICATIONS = gql`
  mutation ConfigureBillChaserNotifications($sendToClients: Boolean!, $sendToIssuers: Boolean!) {
    configureBillChaserNotifications(sendToClients: $sendToClients, sendToIssuers: $sendToIssuers) {
      sendToClients
      sendToIssuers
      scheduleDescription
    }
  }
`;

export const SET_SAFETY_LIMITS = gql`
  mutation SetBillChaserSafetyLimits($maxBillsPerRun: Float!, $minBillAgeInDays: Float!) {
    setBillChaserSafetyLimits(maxBillsPerRun: $maxBillsPerRun, minBillAgeInDays: $minBillAgeInDays) {
      maxBillsPerRun
      minBillAgeInDays
      scheduleDescription
    }
  }
`;

// ==========================================
// Module Deployment Mutations
// ==========================================

export const DEPLOY_MODULES = gql`
  mutation DeployModules {
    deployLatestModules {
      newModules
      deploymentResults {
        tenantId
        tenantName
        success
        error
      }
    }
  }
`;

// ==========================================
// Admin Dashboard Queries
// ==========================================

export const GET_CLIENT_STATS = gql`
  query GetClientStats {
    clientStats
  }
`;

export const GET_PRODUCT_STATS = gql`
  query GetProductStats {
    productStats
  }
`;
